module.exports = __webpack_public_path__ + "6b20d000ca02ac51eccdb095eeb2b1a6.woff2";